module.exports = __webpack_public_path__ + "static/portfolioHeader-08c94acbefbc79a6b8969a463642e1c6.png";